<script>
  import { onMount } from 'svelte'
  import Router, { replace, wrap } from 'svelte-spa-router'
  import SignUp from './auth/SignUp.svelte'
  import Login from './auth/Login.svelte'
  import ConfirmSignUp from './auth/ConfirmSignUp.svelte'
  import GettingStarted from './auth/GettingStarted.svelte'
  import PasswordReset from './auth/PasswordReset.svelte';
  import CreateNewPassword from './auth/CreateNewPassword.svelte';
  import Navbar from './components/Navbar.svelte'
  import Snackbar from './components/Snackbar.svelte'
  import { checkLoggedIn, checkSubscriptionStatus } from './helpers/user-auth'
  
  import Clients from './views/Clients/Clients.svelte'
  import DailyReport from './views/DailyReport/DailyReport.svelte'
  import Settings from './views/Settings/Settings.svelte'
  import ClientDetail from './views/Clients/Client.detail.svelte'
  import Locations from './views/Locations/Locations.svelte'
  import LocationDetail from './views/Locations/Location.detail.svelte'
  import People from './views/People/People.svelte'
  import PeopleDetail from './views/People/People.detail.svelte'
  import { userStore, signatureBlockStore, modalStore } from './state/store'
  import { getTenantData } from './state/actions'
  import { isUserAdmin } from './helpers/utils'

  const handleRouterRedirects = () => {
    const isLoggedIn = checkLoggedIn()
    const isAdmin = isUserAdmin($userStore)
    const subscriptionActive = checkSubscriptionStatus()

    if (isLoggedIn && !isAdmin && subscriptionActive) {
      replace('/locations')
      return
    }

    if (isLoggedIn && !subscriptionActive) {
      replace('/settings')
      return
    }

    if (isLoggedIn && subscriptionActive && isAdmin) {
      replace('/clients')
      return
    }

    replace('/sign-in')
  }

  const routes = {
    '/': Login,
    '/locations/' : wrap(Locations, () => checkLoggedIn() && checkSubscriptionStatus()),
    '/locations/:id' : wrap(LocationDetail, () => checkLoggedIn() && checkSubscriptionStatus()),
    '/people/:id' : wrap(PeopleDetail, () => checkLoggedIn() && checkSubscriptionStatus() && isUserAdmin($userStore)),
    '/clients/:id' : wrap(ClientDetail, () => checkLoggedIn() && checkSubscriptionStatus() && isUserAdmin($userStore)),
    '/clients/' : wrap(Clients, () => checkLoggedIn() && checkSubscriptionStatus() && isUserAdmin($userStore)),
    '/daily-report/' : wrap(DailyReport, () => checkLoggedIn() && checkSubscriptionStatus() && isUserAdmin($userStore)),
    '/settings/' : wrap(Settings, () => checkLoggedIn() && isUserAdmin($userStore)),
    '/people/' : wrap(People, () => checkLoggedIn() && checkSubscriptionStatus() && isUserAdmin($userStore)),
    '/sign-in/': Login,
    '/sign-up/': SignUp,
    '/password-reset/': PasswordReset,
    '/new-password/': CreateNewPassword,
    '/confirm-sign-up/': ConfirmSignUp,
    '/getting-started/': GettingStarted,
  }

  onMount(() => {
    if(checkLoggedIn()) {
      getTenantData()
    }
  })

  $: ($signatureBlockStore.isOpen || $modalStore.isOpen) ?
    document.body.classList.add('scroll-lock') :
    document.body.classList.remove('scroll-lock')

</script>

<style>
  .page {
    display: grid;
    grid-template-rows: auto 1fr;
    grid-template-columns: auto;
    min-height: 100vh;
  }
</style>
<div class="page">
  {#if $userStore.tenant_id} 
    <Navbar />
  {/if}
  <Router {routes} on:conditionsFailed={() => handleRouterRedirects()} />
  <Snackbar />
</div>
